import { cva } from 'class-variance-authority';

/**
 * Every variant is written in theme tokens, so one definition serves both
 * grounds. The focus ring is an `outline` rather than a `ring`: an outline sits
 * outside the element and cannot be clipped by the tab bar or a sticky footer,
 * both of which this app has.
 */
export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition-colors',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
    'disabled:pointer-events-none disabled:opacity-50',
  ].join(' '),
  {
    variants: {
      variant: {
        /**
         * The primary action. Light resolves to brand-700 under white (5.17)
         * and dark to brand-400 under the brown ink (7.53); the old
         * `bg-brand-600 text-white` measured 4.10 and failed AA at body size in
         * the one place a guest must not misread — "Place the order".
         */
        default: 'bg-accent text-on-accent hover:bg-accent-hover',
        secondary: 'bg-surface text-foreground hover:bg-line',
        outline: 'border border-line-strong bg-transparent text-foreground hover:bg-surface',
        ghost: 'text-foreground hover:bg-surface',
        danger: 'bg-negative text-on-negative hover:opacity-90',
      },
      size: {
        sm: 'h-9 px-3',
        md: 'h-11 px-4',
        // Tablet-first staff surfaces need a 56px target (see `touchTarget` in src/lib/ui-tokens).
        lg: 'h-14 px-6 text-base',
        icon: 'h-11 w-11',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
);
